import DateFilter from 'components/brokers/needs_attention/DateFilter'
import { type SingleSelectedValueFilter } from 'components/brokers/types'

const BeforeDateFilter = (props: SingleSelectedValueFilter) => {
  return <DateFilter {...props} rangeType='Less than' />
}

export default BeforeDateFilter
